import { useState } from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import styled from '@emotion/styled'

const StyledButton = styled(Button)`
  ${({ theme, $selected }) => `
    &:hover {
      background-color: ${!$selected ? theme.palette.primary.bgPlus1 : ''};
    }
  `}
`

const checkSelected = (target, filters) => {
  return filters.some((filterUrlId) => filterUrlId === target.urlId)
}

const TagList = ({ category, filters, onChange, defaultCollapse }) => {
  const [isCollapse, setCollapse] = useState(
    defaultCollapse && category?.tags?.length > 6
  )
  const onMoreClick = () => setCollapse(false)

  const onTagClick = (targetTag) => {
    const selectedTagInSameCategory = category?.tags?.find((tag) =>
      filters?.find((filterUrlId) => filterUrlId === tag.urlId)
    )
    if (selectedTagInSameCategory?.urlId === targetTag.urlId) {
      onChange(filters.filter((filterUrlId) => filterUrlId !== targetTag.urlId))
    } else {
      const newFilters = filters
        .filter(
          (filterUrlId) => filterUrlId !== selectedTagInSameCategory?.urlId
        )
        .concat([targetTag.urlId])
      onChange(newFilters)
    }
  }

  return (
    <Grid container spacing={3}>
      {category?.tags?.map(
        (tag, index) =>
          (index < 6 || !isCollapse) && (
            <Grid item xs={4} key={tag._id}>
              <StyledButton
                variant="contained"
                color={checkSelected(tag, filters) ? 'primary' : 'grey'}
                $selected={checkSelected(tag, filters)}
                fullWidth
                onClick={() => onTagClick(tag)}
              >
                <Typography>{tag.name}</Typography>
              </StyledButton>
            </Grid>
          )
      )}

      {isCollapse && (
        <Grid item xs={12}>
          <Button variant="contained" fullWidth onClick={onMoreClick}>
            <Typography>更多{category?.name}</Typography>
          </Button>
        </Grid>
      )}
    </Grid>
  )
}

TagList.defaultProps = {
  defaultCollapse: true,
}

export default TagList
